import { defineMessages } from 'react-intl-next';
export default defineMessages({
  retryPrompt: {
    id: 'fabric.editor.ai.config.item.action.retryPrompt',
    defaultMessage: 'Retry',
    description: 'Retry the latest prompt'
  }
});